exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item__content span[data-v-175a8e08] {\n  margin-left: 10px;\n}\n", ""]);

// exports
